import React, { createContext, useContext, useState } from "react";
import { mockSpendingControlsSymXchange as mockControls, mockCardDetails } from "./mockSpendingControls";
import { mockFetchCardLimits, mockUpdateCardLimits, mapUiStateToApi, mapApiToUiState, getRegoUserId } from "./mockApi";

const SpendingControlsContext = createContext();


export const SpendingControlsProvider = ({ children }) => {
  const [controls, setControls] = useState(() => mockControls.controls);
  const [cardDetails] = useState(() => mockCardDetails);
  const [alerts, setAlerts] = useState(() => mockControls.alerts);
  const [deliveryTargets, setDeliveryTargets] = useState(() => mockControls.deliveryTargets);

  // Update a control by id
  const updateControl = (id, newValue) => {
    setControls((prev) =>
      prev.map((c) => (c.id === id ? { ...c, value: newValue } : c))
    );
  };

  // Update an alert by id
  const updateAlert = (id, newValue) => {
    setAlerts((prev) =>
      prev.map((a) => (a.id === id ? { ...a, value: newValue } : a))
    );
  };

  // Mock fetch from API (future: replace with real API call)
  const fetchCardLimits = async (userId, cardNumber) => {
    const apiResp = await mockFetchCardLimits({ userID: getRegoUserId(userId), cardNumber });
    const mapped = mapApiToUiState(apiResp);
    setControls(mapped.controls);
    setAlerts(mapped.alerts);
    setDeliveryTargets(mapped.deliveryTargets);
  };

  // Mock update to API (future: replace with real API call)
  const updateCardLimits = async (userId, cardNumber) => {
    const payload = mapUiStateToApi({ userId, cardNumber, controls, alerts, deliveryTargets });
    return await mockUpdateCardLimits(payload);
  };

  return (
    <SpendingControlsContext.Provider
      value={{ controls, cardDetails, updateControl, updateAlert, fetchCardLimits, updateCardLimits, alerts, deliveryTargets }}
    >
      {children}
    </SpendingControlsContext.Provider>
  );
};

export const useSpendingControls = () => useContext(SpendingControlsContext);
